export default {
  INIT: 'INIT',
  SET_STATE: 'SET_STATE',
  SET_PROPERTY: 'SET_PROPERTY',
  SET_PROPERTIES: 'SET_PROPERTIES',
};
